var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"styleguide"}},[_c('Icon_styles'),_c('Color_styles')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }